// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2414":"3e897d0e","5027":"cb4f9b56","5262":"2ee9f67a","7076":"37089586","8075":"04c20ec1"}[chunkId] + ".css";
};